import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useRef,
} from 'react'
import Api from 'utils/api'
import * as authHelper from 'utils/auth-helper'
import { useSuperAdmin } from './super_admin'
import Loader from 'component/loader'
import { useAuth } from './auth'

const initOperatorContextPropsState = {
  operator: undefined,
  setOperator: () => {},
  getOperator: async () => {},
}

const OperatorContext = createContext(initOperatorContextPropsState)

const useOperator = () => {
  return useContext(OperatorContext)
}

const OperatorProvider = ({ children }) => {
  const [operator, setOperator] = useState()

  const getOperator = async () => {
    const { response } = await Api('/auth/verify_operator', 'get')
    if (response) setOperator(response.data)
    else setOperator({})
  }

  return (
    <OperatorContext.Provider
      value={{
        operator,
        setOperator,
        getOperator,
      }}
    >
      {children}
    </OperatorContext.Provider>
  )
}

export { OperatorProvider, useOperator }
